import styles from './toolbar.module.scss';
import MaterialToolbar from '@mui/material/Toolbar';

/* eslint-disable-next-line */
export interface ToolbarProps {
  children?: any,
  // classes?: object,
  // component?: any,
  disableGutters?: boolean,
  sx?: any,
  // variant?: 'dense' | 'regular'
}

export function Toolbar(props: ToolbarProps) {
  return (
    <MaterialToolbar
      sx={props.sx}
      disableGutters={props.disableGutters}>
      {props.children}
    </MaterialToolbar>
  );
}

export default Toolbar;